import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";

const WarehouseList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Contact No.",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "primary_email",
      cell: NACell,
    },
    {
      header: "Landmark",
      accessorKey: "landmark",
      cell: NACell,
    },
    {
      header: "Warehouse Manager",
      accessorKey: "warehouse_manager.profile.full_name",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.WAREHOUSE}
      queryKey={"warehouse"}
      columns={defaultColumns}
      addNewPagePath={"/create-warehouse"}
      tableName={"Warehouse"}
    />
  );
};

export default WarehouseList;
